import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { Box, Metadata, useTranslation, useTranslations } from "@bsm/component";
import { useMemo } from "react";
import _ from "lodash";
import moment from "moment";

export const StudentHealthAndImmunisationContainer = () => {
    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);
    const t = useTranslation()

    const value = useMemo(() => data?.heathAndImmunisation, [data])
    const [
        HEALTH_AND_IMMUNISATION,
        MEDICAL_CONDITION,
        VACCINATION_DATES,
        CHICKEN_POX,
        MMR,
        HEPATITIS_B,
        POLIOMYELITIS,
        DTAP,
    ] = useTranslations(i18nKeys)
    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">
            <Box title={HEALTH_AND_IMMUNISATION} className="flex flex-col gap-3 p-10">
                <Metadata label={MEDICAL_CONDITION} value={value?.medicalCondition && value.medicalCondition !== 'NONE' ? t(`BSM.Students.HealthAndImmunisationHistory.MedicalCondition.${value.medicalCondition}.Label`) : '-'} />
                <h3>{VACCINATION_DATES}</h3>
                <Metadata label={CHICKEN_POX} value={!_.isEmpty(value?.chickenPox) ? moment(value?.chickenPox).format('DD-MM-yyyy') : '-'} />
                <Metadata label={MMR} value={!_.isEmpty(value?.mmr) ? moment(value?.mmr).format('DD-MM-yyyy') : '-'} />
                <Metadata label={HEPATITIS_B} value={!_.isEmpty(value?.hepatitisB) ? moment(value?.hepatitisB).format('DD-MM-yyyy') : '-'} />
                <Metadata label={POLIOMYELITIS} value={!_.isEmpty(value?.poliomyelitis) ? moment(value?.poliomyelitis).format('DD-MM-yyyy') : '-'} />
                <Metadata label={DTAP} value={!_.isEmpty(value?.dtap) ? moment(value?.dtap).format('DD-MM-yyyy') : '-'} />
            </Box>
        </div>
    );
}

const i18nKeys = [
    "std_health_and_immunisation",
    "std_medical_condition",
    "std_vaccination_dates",
    "std_chicken_pox",
    "std_mmr",
    "std_hepatitis_b",
    "std_poliomyelitis",
    "std_dtap",
]
